/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Property operation type.
 * Represents the type of transaction for a property.
 */
export enum PropertyOperation {
    SALE = 'SALE',
    RENT = 'RENT',
    SALE_AND_RENT = 'SALE_AND_RENT',
    TEMPORARY_RENT = 'TEMPORARY_RENT',
}
